// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__32U0X","title":"AfterFrontImage_title__2FeTC"};